import {
  getCopyWithContentTableColumn,
  getTimeTableColumn,
} from '@/utils/common/tableColumn'
import { numerify } from '@/filters'
import i18n from '@/locales'

export default {
  created () {
    this.columns = [
      getCopyWithContentTableColumn({
        field: 'id',
        title: i18n.t('scope.text_451'),
      }),
      getCopyWithContentTableColumn({
        field: 'description',
        title: i18n.t('scope.text_869'),
      }),
      {
        field: 'type',
        title: i18n.t('scope.text_827'),
        minWidth: 120,
        formatter: ({ cellValue }) => {
          const obj = {
            alipay: i18n.t('scope.alipay'),
            tenpay: i18n.t('scope.wechat_pay'),
            offline: i18n.t('scope.text_685'),
            revoke: i18n.t('scope.text_690'),
            transfer: i18n.t('scope.text_864'),
            exchange: i18n.t('scope.text_865'),
          }
          return obj[cellValue]
        },
      },
      {
        field: 'amount',
        title: i18n.t('scope.text_647'),
        minWidth: 120,
        formatter: ({ cellValue }) => {
          return numerify(cellValue, '0,0.00')
        },
      },
      {
        field: 'currency',
        title: i18n.t('scope.text_442'),
        minWidth: 70,
      },
      getCopyWithContentTableColumn({
        field: 'source_id',
        title: i18n.t('scope.text_678'),
      }),
      getTimeTableColumn({
        field: 'paid_at',
        title: i18n.t('scope.text_866'),
      }),
      {
        field: 'status',
        title: i18n.t('scope.text_426'),
        formatter: ({ cellValue }) => {
          const obj = {
            init: i18n.t('scope.payment.status.init'),
            complete: i18n.t('scope.payment.status.complete'),
            cancelled: i18n.t('scope.text_456'),
            refunded: i18n.t('scope.payment.status.refund'),
            refunding: i18n.t('scope.payment.status.refunding'),
            refund_failed: i18n.t('scope.payment.status.refund_failed'),
            requesting: i18n.t('scope.payment.status.requesting'),
            failed: i18n.t('scope.payment.status.failed'),
            expired: i18n.t('scope.payment.status.expired'),
          }
          return obj[cellValue]
        },
      },
      {
        title: i18n.t('scope.text_512'),
        field: 'notes',
      },
    ]
  },
}
